import { useQuery } from '@tanstack/react-query';

export function useAccountUserAllowanceQuery() {
  return useQuery({
    queryKey: ['accountUserAllowance'],
    queryFn: async () => {
      const response = await axios.get('/account_user_allowance');

      return response.data;
    },
  });
}
